import {ModelSchema, Structures} from 'octopus-model';

export const notificationDataStructure: ModelSchema = new ModelSchema({
    read: Structures.boolean(false),
    data: Structures.object({}),
    type: Structures.string(),
    date: Structures.date().now(),
    recipient: Structures.number()
});
